/**
 * LeftShortcuts — the "My pages / Saved / Groups / Events" style shortcut
 * strip on the network-style Community left rail. All items point at
 * existing routes in the app so nothing gets orphaned.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import {
  BookmarkIcon, Users, Video, GraduationCap, LayoutList, HelpCircle,
  Trophy, MessageCircle,
} from 'lucide-react';

const ITEMS = [
  { to: '/live',       icon: Video,         label: 'Live sessions', hint: 'Instructor & study rooms' },
  { to: '/study',      icon: Users,         label: 'Study rooms',   hint: 'Peer-hosted, breakout' },
  { to: '/directory',  icon: LayoutList,    label: 'Directory',     hint: 'Operators & vendors' },
  { to: '/graduates',  icon: Trophy,        label: 'Graduates',     hint: 'Wall of certificates' },
  { to: '/dashboard',  icon: GraduationCap, label: 'My learning',   hint: 'Courses in progress' },
  { to: '/messages',   icon: MessageCircle, label: 'Messages',      hint: 'DMs & study buddies' },
  { to: '/community?tab=bookmarks', icon: BookmarkIcon, label: 'Bookmarks', hint: 'Saved threads' },
  { to: '/help',       icon: HelpCircle,    label: 'Help & rules',  hint: 'Community standards' },
];

const LeftShortcuts = () => (
  <aside className="pro-card p-2" data-testid="community-left-shortcuts">
    <div className="px-2 py-1.5 text-[10px] uppercase tracking-widest font-bold text-muted-foreground">
      Explore
    </div>
    <ul className="space-y-0.5">
      {ITEMS.map((it) => (
        <li key={it.to}>
          <Link
            to={it.to}
            className="flex items-center gap-2 rounded-lg px-2 py-2 hover:bg-muted transition-colors group"
            data-testid={`shortcut-${it.label.toLowerCase().replace(/\s+/g, '-')}`}
          >
            <div className="h-7 w-7 rounded-lg bg-primary/10 text-primary flex items-center justify-center flex-shrink-0 group-hover:bg-primary/15">
              <it.icon className="w-3.5 h-3.5" />
            </div>
            <div className="min-w-0 flex-1">
              <div className="text-xs font-bold truncate">{it.label}</div>
              <div className="text-[10px] text-muted-foreground truncate">{it.hint}</div>
            </div>
          </Link>
        </li>
      ))}
    </ul>
  </aside>
);

export default LeftShortcuts;
